import { render, staticRenderFns } from "./Lavado.vue?vue&type=template&id=324f5816&scoped=true&"
import script from "./Lavado.vue?vue&type=script&lang=js&"
export * from "./Lavado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f5816",
  null
  
)

export default component.exports